"use client";

import { useRouter } from "next/navigation";
import UserIcon from "../icons/UserIcon";
import type { User } from "@/contexts/AuthContext";
import { Button } from "@/components";

interface UserMenuProps {
  user: User | null;
  onShowAuthModal: () => void;
}

export default function UserMenu({ user, onShowAuthModal }: UserMenuProps) {
  const router = useRouter();

  if (user) {
    return (
      <Button
        type="button"
        onClick={() => router.push("/account")}
        size="icon-md"
        variant="icon"
        color="white"
        className="relative rounded-lg"
        title={user.email}
      >
        <UserIcon size={24} color="currentColor" />
        <span className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 bg-green-50 rounded-full border-2 border-constant-white" />
      </Button>
    );
  }

  return (
    <Button
      type="button"
      onClick={onShowAuthModal}
      size="icon-md"
      variant="icon"
      color="white"
      className="rounded-lg"
      aria-label="Sign in"
    >
      <UserIcon size={24} color="currentColor" />
    </Button>
  );
}
